import type { SignInConfig } from '#types/config/components/form/signIn'

export default {
  brandClasses: {
    forgotPassword: 'body-4',
    signUp: 'body-4'
  }
} satisfies SignInConfig
